import { Tab, Tabs, styled } from "@mui/material";

const BORDER_COLOR = "#E2E5EC";

const SegmentedTabs = styled(Tabs)(({ theme }) => ({
    minHeight: "40px",
    border: `1px solid ${BORDER_COLOR}`,
    borderRadius: "10px",
    padding: "4px",
    "& .MuiTabs-indicator": {
        display: "none",
    },
    "& .MuiTabs-flexContainer": {
        gap: "4px",
    },
    "& .MuiTab-root": {
        minHeight: "32px",
        borderRadius: "8px",
        textTransform: "none",
        fontWeight: 600,
        fontSize: "14px",
        color: theme.palette.text.secondary,
        padding: "6px 16px",
    },
    "& .Mui-selected": {
        backgroundColor: `${theme.palette.common.white} !important`,
        color: `${theme.palette.primary.main} !important`,
        border: `1px solid ${BORDER_COLOR}`,
    },
}));

export interface ISegmentedTabOption<T> {
    value: T;
    label: string;
    count?: number;
    disabled?: boolean;
}

interface IIotVisionSegmentedTabsProps<T> {
    value: T;
    options: ISegmentedTabOption<T>[];
    onChange: (value: T) => void;
    ariaLabel?: string;
}

const IotVisionSegmentedTabs = <T,>({
    value,
    options,
    onChange,
    ariaLabel,
}: IIotVisionSegmentedTabsProps<T>): JSX.Element => (
    <SegmentedTabs aria-label={ariaLabel} value={value} onChange={(_event, nextValue) => onChange(nextValue)}>
        {options.map((option) => (
            <Tab
                key={String(option.value)}
                value={option.value}
                disabled={option.disabled}
                label={option.count === undefined ? option.label : `${option.label} (${option.count})`}
            />
        ))}
    </SegmentedTabs>
);

export default IotVisionSegmentedTabs;
